module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/level-1_start-3c34962ee162659b4f9c9846412458d4.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/level-1_start.png
// module id = 903
// module chunks = 2